module.exports = __webpack_public_path__ + "img/Weapon_163.c67ce2c7.png";